export enum PlaybackSmoothness {
  Smooth = 'smooth',
  Risky = 'risky',
  Slow = 'slow'
}

export const getSmoothness = (fps: number): PlaybackSmoothness => {
  if (fps < 24) {
    return PlaybackSmoothness.Slow;
  }
  return PlaybackSmoothness.Smooth;
};



// WEBPACK FOOTER //
// ./src/data/PlaybackSmoothness.ts